import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_COMMUNITY_PETITION_USERS = defineFcm('community_petition_users')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'number',
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-front-end',
		context: 'Community Petition Users',
		description: 'User IDs for community petition users',
		import: false,
		template: [],
	});
